import { defineAsyncComponent } from "vue";

export default function (component: string) {
	switch (component) {
		case "files":
			return defineAsyncComponent(() => import('../pages/subview/FilesSubview.vue'));
		case "worksheets":
			return defineAsyncComponent(() => import('../pages/subview/WorksheetsSubview.vue'));
		case "comments":
			return defineAsyncComponent(() => import('../pages/subview/CommentsSubview.vue'));
		case "activities":
			return defineAsyncComponent(() => import('../pages/subview/ActivitiesSubview.vue'));
		case "problems":
			return defineAsyncComponent(() => import('../pages/subview/ProblemsSubview.vue'));
		case "opportunities":
			return defineAsyncComponent(() => import('../pages/subview/OpportunitiesSubview.vue'));
		case "offers":
			return defineAsyncComponent(() => import('../pages/subview/OffersSubview.vue'));
		case "buscases":
			return defineAsyncComponent(() => import('../pages/subview/BusCasesSubview.vue'));
		case "invoices":
			return defineAsyncComponent(() => import('../pages/subview/InvoicesSubview.vue'));
		case "accdocs":
			return defineAsyncComponent(() => import('../pages/subview/AccDocsSubview.vue'));
		case "productcustomers":
			return defineAsyncComponent(() => import('../pages/subview/ProductCustomersSubview.vue'));
		case "campaigns":
			return defineAsyncComponent(() => import('../pages/subview/CampaignsSubview.vue'));
		case "consents":
			return defineAsyncComponent(() => import('../pages/subview/ConsentsSubview.vue'));
		case "changeLogs":
			return defineAsyncComponent(() => import('../pages/subview/ChangeLogSubview.vue'));
		case "facts":
			return defineAsyncComponent(() => import('../pages/subview/FactsSubview.vue'));
		case "warnings":
			return defineAsyncComponent(() => import('../pages/subview/WarningsSubview.vue'));
		case "campaignparties":
			return defineAsyncComponent(() => import('../pages/subview/CampaignPartiesSubview.vue'));
		default:
			return defineAsyncComponent(() => import('./UnknownSubviewComponent.vue'));
	}
};